/** Default frame rate (fps) used when an asset does not specify one. */
export const DEFAULT_FRAME_RATE = 24
